<template>
    <v-container fluid class="text-xs-center"> 
        <v-text-field
            v-model="searchedText"
            placeholder="Cerca..."
          ></v-text-field>
        <div class="results-count">{{customers.length}} Risultati</div>
        <v-layout row wrap justify-center :class="multiselect?'multiselecting':'not-multiselecting'">
            <v-flex xs12 md10>
                <v-card 
                    :class="selectedCustomers.includes(customer.id) ? 'selected' : ''"
                    v-for="customer in filteredCustomers" :key="customer.id" 
                    @click="customerClicked(customer)"
                >
                    <v-card-text>
                        <div class="card-checkbox" v-if="multiselect"><v-icon>check</v-icon></div>
                        <div class="inline-block" style="max-width: calc(100% - 70px);">
                            <strong>{{customer.name}} {{customer.lastname}}</strong><br>
                            Tel. {{customer.telephone}}<br>
                            Cell. {{customer.mobilePhone}}<br>
                            E-mail {{customer.email}}
                        </div>
                        <div class="card-chev" v-if="!multiselect"></div>
                    </v-card-text>
                </v-card>
                <v-btn v-show="customers.length>maxElements" @click="maxElements+=100" style="background:#209ecc;color:white;">
                    Mostra altri risultati...
                </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Conferma eliminazione
                </v-card-title>
                <v-card-text>
                    Vuoi davvero cancellare {{selectedCustomers.length}} clienti?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No, annulla
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deleteCustomers();showDeletionDialog = false"
                >
                    Si, elimina
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn
            color="green"
            dark
            absolute
            bottom
            right
            fab
            v-if="!multiselect"
            @click.native="$router.push({name: 'customerAdd'})"
            style="bottom:20px;font-size:40px;"
            > +
        </v-btn>
        <v-btn
            dark
            absolute
            bottom
            left
            fab
            @click.native="selectedCustomers=[];multiselect=!multiselect;showToast=true"
            style="bottom:20px;"
            > 
            <v-icon style="font-size:40px;padding-left:2px;padding-top:8px;" v-if="multiselect">deselect</v-icon>
            <v-icon style="font-size:40px;padding-left:2px;padding-top:8px;" v-else>select_all</v-icon>
        </v-btn>
        <v-btn
            color="#f44336"
            dark
            absolute
            bottom
            right
            fab
            v-if="multiselect"
            @click.native="showDeletionDialog=true"
            style="bottom:20px;"
            > <v-icon style="font-size:40px;padding-top:5px;">delete</v-icon>
        </v-btn>
        <v-snackbar v-model="showToast">
            Selezione multipla {{multiselect?"attivata":"disattivata"}}
        </v-snackbar>
        <v-snackbar v-model="deletedConfirmToast">
            Clienti eliminati con successo
        </v-snackbar>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Customers',
    data: function(){
        return{
            searchedText: "",
            customers:[],
            selectedCustomers:[],
            multiselect: false,
            showDeletionDialog:false,
            deletedConfirmToast:false,
            showToast: false,
            maxElements: 100
        };
    },
    computed: {
        filteredCustomers(){
            let vm = this;
            if(vm.searchedText=='')
                return vm.customers.slice(0, vm.maxElements);
            return vm.customers.filter(function(el){
                return JSON.stringify(el).toUpperCase().includes(vm.searchedText.toUpperCase());
            }).slice(0, vm.maxElements);
        }
    },
    mounted: function(){
        let vm = this;
        vm.getCustomers();
    },
    methods:{
        deleteCustomers(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "deleteCustomers.php",
                data: {
                    "customers":vm.selectedCustomers
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.selectedCustomers=[];
                    vm.getCustomers();
                    vm.deletedConfirmToast = true;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        },
        customerClicked(customer){
            let vm = this;
            if(vm.multiselect){
                if(vm.selectedCustomers.includes(customer.id)){
                    vm.selectedCustomers.splice(vm.selectedCustomers.indexOf(customer.id),1);
                }
                else{
                    vm.selectedCustomers.push(customer.id);
                }
            }
            else{
                vm.$router.push({name: 'customer', params:{customerId:customer.id}});
            }
        },
        getCustomers(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getCustomers.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.customers = [];
                    vm.customers = response.data.resources;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>

